import React, { useEffect, useState } from 'react';
import {navigate, safeFetch} from './App';
import {cacheSafeFetch} from "./cacheSafeFetch";

export default function CreateCommunityPost({ chatId, postType, onSubmitSuccess, zoneId }) {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState(null);
    const [pollOptions, setPollOptions] = useState(['', '']);
    const [zones, setZones] = useState([]);
    const [selectedZone, setSelectedZone] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    useEffect(() => {
        const fetchZones = async () => {
            try {
                const res = await cacheSafeFetch(`https://j1gefbe2q0.execute-api.us-west-2.amazonaws.com/default/zones-and-categories`, chatId, { method: 'GET' }, { cacheKey: `zones-and-categories-${chatId}` });
                const data = await res.json();
                setZones(data.zones || []);
            } catch (err) {
                console.error('Failed to fetch zones', err);
            }
        };

        fetchZones();
    }, []);

    const handlePollChange = (index, value) => {
        const updated = [...pollOptions];
        updated[index] = value;
        setPollOptions(updated);
    };

    const addPollOption = () => {
        if (pollOptions.length < 5) setPollOptions([...pollOptions, '']);
    };

    const handleSubmit = async () => {
        setSubmitting(true);
        setError(null);
        const newErrors = {};

        if (!title.trim()) newErrors.title = true;
        if (!zoneId && !selectedZone) newErrors.zone = true;

        if (postType === 'poll') {
            const filledOptions = pollOptions.filter(opt => opt.trim());
            if (filledOptions.length < 2) newErrors.pollOptions = true;
        } else {
            if (!description.trim()) newErrors.description = true;
        }

        if (Object.keys(newErrors).length > 0 ) {
            //setFieldErrors(newErrors);
            setError('נא למלא את כל השדות החובה');
            setSubmitting(false);
            return;
        }

        //setFieldErrors({});

        const payload = {
            type: postType,
            chatId,
            title,
            description: postType === 'poll' ? undefined : description,
            image,
            zone: selectedZone || zoneId,
            pollOptions: postType === 'poll' ? pollOptions.filter(opt => opt.trim()) : undefined,
        };

        try {
            const res = await safeFetch('https://j1gefbe2q0.execute-api.us-west-2.amazonaws.com/default/submit-post', chatId,{
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            if (res.ok) {
                setSubmitted(true);
                setTitle('');
                setDescription('');
                setPollOptions(['', '']);
                setSelectedZone('');
                setImage(null);
                onSubmitSuccess();
            } else {
                const errText = await res.text();
                setError('שליחה נכשלה: ' + errText);
            }
        } catch (err) {
            console.error('Error sending post:', err);
            setError('שגיאה בשליחה. נסה שוב.');
        }

        setSubmitting(false);
    };

    return (
        <div className="max-w-md mx-auto mt-10 p-6 bg-white bg-opacity-90 rounded-xl shadow-md text-black space-y-4">
            {postType === 'poll' ? (
                <>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="כותרת לסקר"
                        className="w-full p-2 border rounded"
                    />
                    {pollOptions.map((opt, idx) => (
                        <input
                            key={idx}
                            type="text"
                            value={opt}
                            onChange={(e) => handlePollChange(idx, e.target.value)}
                            placeholder={`אפשרות ${idx + 1}`}
                            className="w-full p-2 border rounded mb-2"
                        />
                    ))}
                    {pollOptions.length < 5 && (
                        <button
                            onClick={addPollOption}
                            className="text-sm text-info-600 underline font-semibold"
                        >
                            הוסף אפשרות נוספת
                        </button>
                    )}
                </>
            ) : (
                <>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="כותרת"
                        className="w-full p-2 border rounded"
                    />
                    <textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="תיאור"
                        rows={4}
                        className="w-full p-2 border rounded"
                    />
                    {/*<input*/}
                    {/*    type="file"*/}
                    {/*    accept="image/*"*/}
                    {/*    onChange={(e) => {*/}
                    {/*        const file = e.target.files[0];*/}
                    {/*        if (file) {*/}
                    {/*            setImage(file);*/}
                    {/*            const reader = new FileReader();*/}
                    {/*            reader.onloadend = () => {*/}
                    {/*                setImagePreview(reader.result);*/}
                    {/*            };*/}
                    {/*            reader.readAsDataURL(file);*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*    className="w-full"*/}
                    {/*     />*/}

                    {/*{imagePreview && (*/}
                    {/*    <img src={imagePreview} alt="preview" className="w-full h-48 object-cover rounded-lg mt-2" />*/}
                    {/*)}*/}
                </>
            )}
            { !zoneId && (
                <div>
                    <h3 className="font-bold mt-4 mb-2">בחר.י מקומית לפרסום הפוסט</h3>
                    <div className="grid grid-cols-2 gap-2">
                        {zones.map((zone) => (
                            <label key={zone} className="flex items-center">
                                <input
                                    type="radio"
                                    name="zone"
                                    value={zone}
                                    checked={selectedZone === zone}
                                    onChange={() => setSelectedZone(zone)}
                                    className="ml-2"
                                />
                                {zone}
                            </label>
                        ))}
                    </div>
                </div>
            )}
            {submitted ? (
                <div className="text-success-700 font-bold text-center">✅ הפוסט נשלח בהצלחה</div>
            ) : (
                <button
                    onClick={handleSubmit}
                    disabled={submitting}
                    className={`w-full py-2 rounded-lg font-bold transition ${submitting ? 'bg-line-strong' : 'bg-success-600 hover:bg-success-700'} text-white`}
                >
                    {submitting ? 'שולח...' : 'שלח'}
                </button>
            )}

            {error && (
                <div className="text-danger-600 text-sm text-center mt-2 font-bold">
                    {error}
                </div>
            )}
        </div>
    );
}
